<template>
    <div class="container-fluid maintenance-planner-container">
        <div class="row no-print">
            <div class="col-sm-12 text-right">
                <select
                    v-model="type"
                    @change="loadSites"
                >
                    <option value="fire_alarm">
                        Fire Alarm
                    </option>
                    <option value="fire_ex">
                        Fire Extinguisher
                    </option>
                </select>
                <button
                    class="btn btn-primary"
                    @click="print"
                >
                    Print
                </button>
            </div>
        </div>

        <table class="table table--bordered maintenance-planner-table">
            <thead class="text-center">
                <tr class="maintenance-planner-table__header">
                    <th colspan="1">
                        <img
                            v-if="sysSetting('company_logo')"
                            :src="sysSetting('company_logo')"
                            alt="Logo"
                            class="maintenance-kpi__logo"
                        >
                    </th>
                    <th
                        colspan="20"
                        class="maintenance-kpi__company"
                    >
                        {{ sysSetting('company_name') }}
                    </th>
                    <th colspan="4">
                        {{ year }}
                    </th>
                </tr>
                <tr>
                    <th class="maintenance-planner-table__customer">
                        Customer
                    </th>
                    <th
                        v-for="month in months"
                        :key="month.date.month()"
                        colspan="2"
                    >
                        {{ month.date.format('MMMM') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="site in sites"
                    :key="site.site_id"
                >
                    <td class="maintenance-planner-table__customer">
                        <strong>{{ site.customer.company_name }}</strong>
                        <span>{{ site.name }}</span>
                    </td>
                    <td
                        v-for="month in doubleMonths"
                        :key="site.site_id + '_' + month.type + '_' + month.date.month()"
                    >
                        <span v-if="month.type === 'due' && isDue(site, month)">Due</span>
                        <span v-else-if="month.type === 'complete' && isComplete(site, month)">Comp</span>
                        <span v-else>&nbsp;</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import SettingsMixin from '../../mixins/SystemSettings';
export default {
    mixins: [
        SettingsMixin,
    ],
    data() {
        return {
            year: window.moment().format('YYYY'),
            sites: [],
            type: 'fire_alarm'
        };
    },

    computed: {
        months() {
            const months = [];

            for (let i = 0; i < 12; i++) {
                months.push({
                    date: window.moment().startOf('year').month(i),
                });
            }
            return months;
        },

        doubleMonths() {
            const months = [];

            for (let i = 0; i < 12; i++) {
                months.push({
                    date: window.moment().startOf('year').month(i),
                    type: 'due',
                });
                months.push({
                    date: window.moment().startOf('year').month(i),
                    type: 'complete',
                });
            }
            return months;
        },
    },

    mounted() {
        this.loadSites();
    },

    methods: {
        print() {
            window.print();
        },
        loadSites() {
            window.axios.get('/api/maintenance/sites', {params: {year: this.year, type: this.type}}).then(res => {
                this.sites = res.data;
            }).catch(err => {
                window.alert('Error: Failed to load maintenance planner');
                throw err;
            })
        },

        findReminder(site, month) {
            return site.service_reminders.find(reminder => (reminder.month -1) === month.date.month() && reminder.type === this.type);
        },

        isDue(site, month) {
            const reminder = this.findReminder(site, month);
            if (reminder) {
                return true;
            }
        },

        isComplete(site, month) {
            const reminder = this.findReminder(site, month);
            if (reminder && reminder.status === 'done') {
                return true;
            }

            return false;
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/MaintenancePlannerComponent.vue